import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PlanningPortalGlobalState } from '../../../state/planning-portal-global-state/planning-portal-global.state';

@Injectable()
export class HttpTenantInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Check if the URL contains 'login'
    if (req.url.includes('/api/Account/Login')) {
      return next.handle(req);
    }

    const tenantId = this.store.selectSnapshot(
      PlanningPortalGlobalState.TenantId
    );

    const request = req.clone({
      setHeaders: {
        tenantId: tenantId ?? '',
        DistributionLanes: 'BE77BE35-9709-4239-8B9F-079CA0AB7183',
      },
    });

    return next.handle(request);
  }
}
